// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app {
  display: flex;
  flex-direction: row;
  max-width: 100vw;
  min-height: 100vh;
  overflow-x: clip;
}
.app .router-switch {
  background: #f5fbff;
  flex-grow: 1;
  max-height: 100%;
  max-width: 100%;
}
.app ::-ms-reveal {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/pages/App.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;AACF;AACE;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;AACJ;AAEE;EACE,aAAA;AAAJ","sourcesContent":[".app {\n  display: flex;\n  flex-direction: row;\n  max-width: 100vw;\n  min-height: 100vh;\n  overflow-x: clip;\n\n  .router-switch {\n    background: #f5fbff;\n    flex-grow: 1;\n    max-height: 100%;\n    max-width: 100%;\n  }\n\n  ::-ms-reveal {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
